// frontend/src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./components/LandingPage/LandingPage";
import CategoryPage from "./components/CategoryPage/CategoryPage";
import ArtworkPage from "./components/ArtworkPage/ArtworkPage";
import Login from "./portal/Login";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./portal/AuthCallback";
import AdminLandingPage from "./portal/pages/AdminLandingPage";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./Layout";
import ArtistList from "./components/Artists/ArtistList";
import AboutArtStudio from "./components/About/AboutArtStudio";
import ArtistArtworkList from "./components/Artists/ArtistArtworkList";
import ArtTags from "./components/LandingPage/ArtTags";
import ArtTagPage from "./components/CategoryPage/ArtTagPage";
import AdminArtTagPage from "./portal/pages/AdminArtTagPage";
import AdminArtworkListPage from "./portal/pages/AdminArtworkListPage";
import AdminArtworkDetailsPage from "./portal/pages/AdminArtworkDetailsPage";
import AdminArtistList from "./portal/pages/AdminArtistList";
import AdminArtistArtwork from "./portal/pages/AdminArtistArtwork";
import AdminArtistArtworkDetailsPage from "./portal/pages/AdminArtistArtworkDetailsPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<Layout />}>
            {/* Landing page - shows all categories */}
            <Route path="/" element={<LandingPage />} />

            <Route path="/category/:categoryId/tags" element={<ArtTags />} />

            <Route
              path="/category/:categoryId/tag/:tagId"
              element={<ArtTagPage />}
            />

            {/* Category page - shows artworks in a category */}
            <Route path="/category/:categoryId" element={<CategoryPage />} />

            {/* Artwork detail page */}
            <Route path="/artwork/:artworkId" element={<ArtworkPage />} />

            {/* Artist list - shows all Artists */}
            <Route path="/artists" element={<ArtistList />} />

            {/* Artist artworks - shows artworks of the selected Artists */}
            <Route path="/artist/:artistId" element={<ArtistArtworkList />} />

            <Route path="/about" element={<AboutArtStudio />} />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />

            {/*Auth Portal Routes */}
            <Route path="/portal/login" element={<Login />} />
            <Route path="/portal/auth-callback" element={<AuthCallback />} />

            {/*Admin Pages Routes */}
            <Route
              path="/portal"
              element={
                <ProtectedRoute>
                  <AdminLandingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/portal/category/:categoryId/tags"
              element={
                <ProtectedRoute>
                  <AdminArtTagPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/portal/category/:categoryId/tag/:tagId"
              element={
                <ProtectedRoute>
                  <AdminArtworkListPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/portal/category/:categoryId/tag/:tagId/artwork/:artworkId"
              element={
                <ProtectedRoute>
                  <AdminArtworkDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/portal/student/:artistId/artwork/:artworkId"
              element={
                <ProtectedRoute>
                  <AdminArtistArtworkDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/portal/students"
              element={
                <ProtectedRoute>
                  <AdminArtistList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/portal/student/:artistId/artworks"
              element={
                <ProtectedRoute>
                  <AdminArtistArtwork />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
